export const messages = {
  en: {
    shopVipLevel: {
      title: 'Shop VIP Level',
      queryConditions: 'Query Conditions',
      levelName: 'Level Name',
      vipLevel: 'VIP Level',
      levelId: 'Level ID',
      search: 'Search',
      reset: 'Reset',
      addLevel: 'Add Level',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      remark: 'Remark',
      createTime: 'Create Time',
      levelDescription: 'VIP levels from high to low: Level 1, Level 2, Level 3'
    }
  },
  zh: {
    shopVipLevel: {
      title: '店铺会员等级',
      queryConditions: '查询条件',
      levelName: '会员名称',
      vipLevel: '会员等级',
      levelId: '等级编号',
      search: '查询',
      reset: '重置',
      addLevel: '添加等级',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      confirmDelete: '确认删除',
      cancel: '取消',
      remark: '说明',
      createTime: '创建时间',
      levelDescription: '会员等级从大到小依次为：一级、二级、三级'
    }
  }
}